import { t } from "@lingui/macro"
import { FormControl } from "@mui/material"
import { observer } from "mobx-react"
import { useCallback, useMemo } from "react"

import { AutoCompleteTextField } from "src/components/AutoCompleteTextField"

import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { useStore } from "src/store/lib/useStore"

export const KnowledgeItemsAgentAccess = observer(() => {
    const store = useStore(KnowledgeItemStore)
    const error = store.formFields.error("agents")
    const isLoadingAgentTypes = store.isLoadingAgentTypes

    // Get agent type options only
    const agentOptions = useMemo(
        () => store.agentAccessTypes,
        [store.agentAccessTypes],
    )

    const handleChange = useCallback(
        async (_event, value) => {
            // For multiselect, value will be an array, but handle all cases for type safety
            const agentTypes = Array.isArray(value) ? value : []
            await store.setSelectedAgentTypes(agentTypes)
        },
        [store],
    )

    const hasError = useMemo(() => Boolean(error), [error])

    return (
        <FormControl sx={{ breakInside: "avoid" }}>
            <AutoCompleteTextField
                multiple
                disableCloseOnSelect
                options={agentOptions}
                value={store.getAgentTypeValue()}
                placeholder={t`knowledge-item-modal.agent-access`}
                onChange={handleChange}
                loading={isLoadingAgentTypes}
                error={hasError}
                helperText={error ?? undefined}
            />
        </FormControl>
    )
})
